// extracted by mini-css-extract-plugin
export default {"modalOverlay":"_T-z","modalContent":"aU-z","header":"bU-z","close":"cU-z"};